module.exports = __webpack_public_path__ + "static/media/CaseNest_Purple_Positive_RGB (1).24929da0.svg";